import type { FlattenedSectionProps } from "../../../components/Questionnaire/Section";
import type { QuestionnaireState } from "../types";

export const makeFullAddress = (
  questionName: string,
  state: Partial<QuestionnaireState>,
): string => {
  const { sections: sectionsFromState, answers = {} } = state;
  const sections = sectionsFromState as unknown as FlattenedSectionProps[];
  const question = sections
    .flatMap(section => section.questions)
    .find(q => q.name === questionName);

  if (!question) {
    return "";
  }

  // Find question names for mapped fields
  const mappedFields = question.display.config?.mappedFields || [];
  const questionIds = Array.isArray(mappedFields)
    ? (mappedFields as { associatedQuestionId: string }[]).map(
        field => field.associatedQuestionId,
      )
    : [];
  // Question names will always appear in correct order in sections :)
  const questionNames = sections
    .flatMap(section => section.questions)
    .filter(q => questionIds.includes(q.id))
    .map(q => q.name);

  // Get answers for mapped fields
  const manualAnswers = questionNames.map(name => answers[name]);
  const fullAddress = manualAnswers.filter(Boolean).join(", ");

  return fullAddress;
};
